import { AnimatePresence, type Variants } from 'framer-motion';
import { useShipmentFiltersContext, useShipmentsOverviewContext } from '@/modules/pmt/context';
import { SORT_OPTIONS, FILTER_OPTIONS } from '@/modules/pmt/constants';
import { NoParcelsFound } from '../NoParcels';
import { Shipments } from './components/Shipments';
import { DeliveredShipments } from './components/DeliveredShipments';
import { AnimateListWrapper } from './ShipmentList.styles';

const animationVariantsBoxContainer: Variants = {
  hidden: {
    opacity: 0,
    transition: {
      staggerChildren: 0.3,
      delayChildren: 0.3,
    },
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
      delayChildren: 0.3,
    },
  },
};

export const ShipmentList = () => {
  const { filterConfig } = useShipmentFiltersContext();
  const { noShipmentsFound } = useShipmentsOverviewContext();

  if (noShipmentsFound) return <NoParcelsFound />;

  const showDeliveredShipments =
    filterConfig.currentFilter === FILTER_OPTIONS.ALL && filterConfig.currentSort === SORT_OPTIONS.DELIVERY_DATE;

  return (
    <AnimateListWrapper exit='hidden' animate='show' initial='hidden' variants={animationVariantsBoxContainer}>
      <AnimatePresence>{showDeliveredShipments && <DeliveredShipments />}</AnimatePresence>
      <AnimatePresence>
        <Shipments />
      </AnimatePresence>
    </AnimateListWrapper>
  );
};
